import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const getPriceCollectionDocumentsWithConditionsSchema = z.array(
  baseObjectSchema.extend({
    documentHeader: z.object({
      id: z.string(),
      documentNumber: z.number(),
      remarks: z.string().optional(),
    }),
    salesPerson: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    traderSite: z.object({
      id: z.string(),
      code: z.string().optional(),
      name: z.string().optional(),
    }),
    sendDate: z.string().optional(),
    isCompetitorPriceCollection: z.boolean(),
  })
);

export type GetPriceCollectionDocumentsResponse = z.infer<
  typeof getPriceCollectionDocumentsWithConditionsSchema
>;
